import React from "react";
import { useSelector } from "react-redux";
import AddProduct from "./AddProduct";
import ProductItem from "./ProductItem";

const Home = () => {
  const { products } = useSelector((state) => state.shopping);

  return (
    <div className="productWrapper">
      {/* products container */}
      <div className="productContainer" id="lws-productContainer">
        {/* product item */}
        {products.map((item) => (
          <ProductItem key={item.id} item={item} />
        ))}
        {products.length === 0 && (
          <h2 className="mb-8 text-xl font-bold">No Product Found</h2>
        )}
        {/* product item ends */}
      </div>
      {/* products container ends */}
      <div>
        {/* Product Input Form */}
        <AddProduct />
        {/* Product Input Form Ends */}
      </div>
    </div>
  );
};

export default Home;
